export default {
  scope: ({ site, path }) => site.includes('titanium') || path.includes('titanium'),
  colors: { brand: '#535366' },
  fonts: { heading: 'Gin-Regular, sans-serif' },
};
